import { render, staticRenderFns } from "./fieldset-textarea.vue?vue&type=template&id=4dc4c193&lang=pug&"
import script from "./fieldset-textarea.vue?vue&type=script&lang=js&"
export * from "./fieldset-textarea.vue?vue&type=script&lang=js&"
import style0 from "./fieldset-textarea.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports